// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"styles_menuItems__24xMd","narrowSubmenu":"styles_narrowSubmenu__31tsP","trendingCategoryMenu":"styles_trendingCategoryMenu__1j3xX"};